export default __webpack_public_path__ + "static/media/wifi-sinal.76318535.png";